class SbLib
{
    constructor(options)
    {
        $.extend(this, new SbEvents());

        this.options = {
            path: null, // path to project
            library: null, //image or folder
            mode: "image",
            title: 'Library',
            id: null,
          //  field: 'image',
            field: null,
            value: null,
            type : 'image',
            extensions : [
                'gif',
                'jpg',
                'jpeg',
                'png'
            ],
            icons : {}
        };

        if (options) {
            this.options = $.extend(null, this.options, options);
        }

        this.dialog = null;
        this.folder = 0; // id of current folder
        this.dragData =  {};
        this.partials = null; // html partials
        this.clickTimeout =  null;
        this._escapes = [];


        this._HTML5 = window.FileReader ? true :  false;

        /* variables */
        this.title = 'Images';
        this.currentResource = null;
        this._filesToUpload = [];
        this._cut = null;
        this.mode = null;
        this.library_info = {};
        this.home_title = null;
    }

    open() 
    {

        var self = this;
    //    this.folder = 0;

        this.value = null;
        if (this.element) {
            this.value = this.element.nodeType ? this.element.getAttribute(this.fieldName) : this.element[this.fieldName];
        } else if (this.field) {
            this.value = this.field.value;
        }

        $.get(self.options.path + "/template.html", function(html)
        {
            var dialog = self.dialog = new jqueryDialog(document.body, function()
            {
                dialog.dialog.append(html);
                self.cont = dialog.dialog;
                
                self.partials = $(".sblib-partials", self.cont).detach();

                self._addEvents();
            }, {
                'id' : 'sblib',
                'position' : 'none',
                'close' : true,
                'underlay' : true,
                class: "dialog sb-admin"
            }).open();    
        
            $(dialog).on('afteropen', function()
            {
                self.trigger('open');
            //    $(document.body).css({"overflow": "hidden", "height" : "100%"});
            
                // prevent body scrolling when window is open
                var body = $(document.body);
                var scrollTop = $(document).scrollTop();
                var scrollLeft = $(document).scrollLeft();
                body.css({"overflow": "hidden", height: "100%"});
                body.scrollTop(scrollTop);
                body.scrollLeft(scrollLeft);
            });    

            $(dialog).on('afterclose', function()
            {
                // restore body scroll to original state
                var body = $(document.body);
                var scrollTop = body.scrollTop();
                var scrollLeft = body.scrollLeft();
                body.css({"overflow": "", "height" : ""});
                $(document).scrollTop(scrollTop);
                $(document).scrollLeft(scrollLeft);

                $(document).off('.sblib-event');

                self.trigger('close');
            });    

        });



            
    /*
        $.get(SB_FILES+'/API/sblib/library_info.php', {library : this.library}, function (info)
        {
            if (!info) {
                return;
            }

            if (info.mode == 'images') {
            }

            if (info.types) {
                self.options.types = info.types;
            }
            self.library_info = info;

            if (self.home_title) {
                self.home_title.innerHTML = info.title;
            }
        });
    */
    }

    remove()
    {
        var self = this;

        // KS: this seems redundant
        if (this.field) {
            this.field.value = null;
        }

        if (this.options.field) {
            var field = $(this.options.field)
            .val('');

            var cont = field.closest(".sblib-field");

            var icon = cont.find(".sblib-thumb-image");
            var filename = cont.find(".sblib-thumb-filename");
            var thumb = cont.find(".sblib-thumb");
            var noImage = cont.find(".sblib-no-image");
            
            thumb.fadeOut(function()
            {
                icon
                .prop('src', '')
                 .prop('title', '');

                filename
                .prop('title', '')
                .empty();


                noImage.fadeIn();
            });

        /*
            var button = field.parent().find("button.sblib-thumb-remove")
            .fadeOut();
        */
        }
    }

    _addEvents()
    {
        var self = this;

        $(".sblib-cont", self.cont).addClass("sblib-mode-" + self.options.type);

        $(".sblib-help-button", self.cont).dialogClick($(".sblib-help-cont", self.partials).prop('outerHTML'), {
            'stem' : true,
            'position' : 'right-top'
        });

        /**
        * Cut Functionality
        **/
        $(document).on('keydown.sblib-event', function(evt)
        {
            // Close dialog components on escape

        /*
            if (evt.which == 27) {
                if (self._escapes.length) {
                    $(document.activeElement).blur(); // force input to fire blur event for ajax save
                }
                
                self.clearEscape();
            }
        */

            var ctrlKey = (evt.ctrlKey === true || evt.metaKey === true);
            
            /* Detect Control + x (cut)
            */
        /*
            //XXX this code in its present state interferes wiht pasting in altenative text
            if (ctrlKey === true && evt.which == 88) {
                var files = [];
            
                $(".resource.selected", self.main).addClass("cut");

                $(".resource.cut", self.main).each(function()
                {
                    files.push(this.resource.set);
                });
            
                self._cut = files.join(',');

                evt.stopPropagation();
                evt.preventDefault();
            }
        */

            /* Detect Control + v (paste)
            */
        /*
            if (ctrlKey === true && evt.which == 86) {
                if (self._cut) {
                    self.move(self.folder);
                }
                evt.stopPropagation();
                evt.preventDefault();
            }
        */
        });    

        /**
        * Buttons
        **/

    /*
        $(".sblib-new-folder", self.cont)
        .on('click', function(evt)
        {
            self.new_folder();
            return false;
        });
    */

        $(".sblib-browse input", self.cont)
        .on('change', function()
        {
            if (!window.FileReader) {
                alert("HTML5 File upload support is required to use this feature");
                return;
            }
            
            for (var i = 0, file; (file = this.files[i]); i++) {
                self.queue(file);
            }    
            this.value = '';
        });

        $(".sblib-primary", self.cont)
        .on('click', function()
        {
         //   self.deselect_all();
        });

        $(".sblib-primary", self.cont)
    /*
        .on('concontextmenu', ".sblib-file", function(evt) 
        { 
            if ($(this).hasClass('uploading') == true) {
                return;
            }

            var menu = sb_contextMenu(evt);
            sblib_menu.call(self, menu, this);
            return false; 
        })
    */
        .on("click", ".sblib-file", function(evt)
        {
            var node = $(this);
            if (!self.clickTimeout) {
                self.clickTimeout = setTimeout(function()
                {
                    self.clickTimeout = null;
                    self.addEditor(node);
                }, 300);
            }

        /*
            if (evt.button == 2) {
                node.addClass('selected');
                return;
            }
        */

        /*
            var parent = node.parent();

            // Select node
            $('.cut', self.main).removeClass('cut');
            if (evt && (evt.ctrlKey == true || evt.metaKey == true)) {
                node.toggleClass('selected');            
            } else if (evt.shiftKey == true) {
                var clicked  = null;
                if ((clicked = node.prevAll(".last-clicked")).length) {
                    parent.children(".resource").slice(clicked.index(), node.index() + 1).addClass('selected');
                } else if ((clicked = node.nextAll(".last-clicked")).length) {
                    parent.children(".resource").slice(node.index(), clicked.index()).addClass('selected');
                } else {
                    node.addClass('selected');
                }
            } else {
                $(this).siblings(".selected").removeClass('selected');
                // node.data('deselect-all', true);
                node.addClass('selected');
            }
        */
    
            evt.stopPropagation();
        })
    /*
        .on("mouseup", ".sblib-file", function(evt)
        {
            if ($(this).data('deselect-all')) {
            // $('.selected', self.main).removeClass('selected');
                $(this).siblings(".selected").removeClass('selected');
                $(this).data('deselect-all', '');
            }
        })
    */
        .on("click", ".sblib-file", function(evt)
        {
        /* Prevent file froom getting deselected
        */
            var node = this;

            $(this).siblings(".sblib-files").removeClass('last-clicked');
            $(this).addClass('last-clicked');

        /*
            var info = (this).data('info');
            if (this.image || this.file) {
                var info = node.resource;
                var value = info.value;
                var post = 'set=' + value;
                post += '&mode=' + node.mode;
                sb_req(SB_FILES+'/API/sblib/more_info.php', sblib_more_info_req, post, self);
            }
        */

            evt.stopPropagation();
        })
        .on("dblclick", ".sblib-file",  function()
        {
            if ($(this).hasClass('uploading')) {
                return;    
            }

            if (self.clickTimeout) {
                clearTimeout(self.clickTimeout);
                self.clickTimeout = null;
            }

            self.choose($(this).data('info'));

        //    sblib_dbl_click(this, self);
        })

        // Drag and drop events
        .on('dragstart', ".sblib-file", function(evt) 
        {
            if ($(this).hasClass('uploading') === true) {
                return;
            }
            
            var info = $(this).data('info');

            self.dragData = {
                dragging: this,
                action: 'moveFile',
                files: info.value,
                nodes: [this],
                order: self.getFileOrder(),
                folderChange: false
            };

            $(this).fadeTo(200, 0.5);

            var dt = evt.originalEvent.dataTransfer;
            dt.clearData();
       //     dt.setData("action", "moveFile");
            dt.effectAllowed = 'move';
            dt.setData("Text", "");
            return true;
        })
        .on('dragend', '.sblib-file', function() 
        {
            var newOrder = self.getFileOrder();
            $(".sblib-folders", self.cont).find(".hierarchy-row, .sblib-home").data('counter', null);
            
            if (self.dragData.folderChange === false) { 
                $(this).fadeTo(200, 1);
                if (self.dragData.order == newOrder) {
                    self.dragData = {};
                    return true;
                }
            }
            
            self.action('reorder', {order: newOrder}, function()
            {
            
            });
            
            self.dragData = {};
            return true;
        })
        .on('drag', ".sblib-file", function() 
        {
            return false;
        })
        .on("dragenter", ".sblib-file", function(evt)
        {
            if (self.dragData.action != "moveFile") {
                return;
            }

            if (self.dragData.dragging === this || $(this).hasClass('uploading') === true) {
                return;
            }
            
            if ($(self.dragData.dragging).index()  > $(this).index()) {
                $(this).before(self.dragData.dragging);
            } else {
                $(this).after(self.dragData.dragging);
            }

            evt.preventDefault();
            evt.stopPropagation();
        });

        /** 
        * DND File Upload Events
        **/
        $(document).on('dragover.sblib-event', function(evt)
        {
            evt.stopPropagation();
            evt.preventDefault();

            var dt = evt.originalEvent.dataTransfer;
            dt.effectAllowed = dt.dropEffect = 'none';

            return false;
        });


        $(".sblib-primary", self.cont)
        .on('dragenter', function(evt)
        {
            evt.stopPropagation();
            evt.preventDefault();
        })
        .on('dragover', function(evt)
        {
            evt.stopPropagation();
            evt.preventDefault();

            var dt = evt.originalEvent.dataTransfer;
            if (dt.getData('action') == 'moveFile') {
                dt.effectAllowed = dt.dropEffect = 'none';
            }
    
        })
        .on('drop', function(evt)
        {
            evt.stopPropagation();
            evt.preventDefault();

            var dt = evt.originalEvent.dataTransfer;
            for (var i = 0, file; (file = dt.files[i]); i++) {
                self.queue(file);
            }
        });

        this.render();
    }

    render() 
    {
        var folderId;

        $(".sblib-title-cont", this.cont).text(this.options.title);        

        if (this.options.mode == "folder") {
            folderId = $(this.options.field).val() ||  "0";
            this.renderFilePane(folderId);
           
            var self = this;
   
        } else {
            folderId = sessionStorage.getItem('sblib_folder_' + this.options.library) || "0";
            this.renderFilePane(folderId);
        }

        var folderPromise = this.renderFolderPane(folderId);
    /*
            folderPromise.done(function()
            {

                var folder = $(".sblib-folders", self.cont).find("li[data-id=" + folderId + "]");
                folder.addClass('is-active');
            });
        */


    /*
        sb_req(SB_FILES+'/API/sblib/file_info.php', sblib_file_info_req, post, this);
        sb_req(SB_FILES+'/API/sblib/folder_info.php', sblib_folder_info_req, post, this);
        sb_req(SB_FILES+'/API/sblib/folders.php', sblib_folder_req, post, this);
    */
    }
    
    renderFilePane(folder)
    {
        sessionStorage.setItem('sblib_folder_' + this.options.library, folder);
        
        this.activeFolder(folder);

        var self = this;
        var post = {
          //  library : this.library,
            folder : folder
        };

        this.folder = folder;

        if (this.options.type == 'file') {
            // Corect header to "Files" from "Images" (as per template)
            $(".sblib-primary .sb-section-head", this.cont).text('Files'); 
        }

        $.post(this.options.url + '/list', post, function(data)
        {
            if  (!data || data.type != 'list') {
                return;
            }
            $('.sblib-files', self.cont).empty();
            
            self.data = data;

            for (var i = 0, info; (info = data.files[i]); i++) {
                self.addFile(info);
            }
        });
    }

    activeFolder(folder)
    {
        $('.hierarchy-base .is-active', this.cont).removeClass('is-active');
        $('.sblib-home.is-active', this.cont).removeClass('is-active');

        $(".sblib-folder-" + folder).addClass("is-active");
    }

    renderInline(selector)
    {
        this._inline = true;
        var self = this;
        this.cont = $(selector);
        
        $.get(this.options.path + "/template.html", function(html)
        {
            self.cont.html(html);
                
            self.partials = $(".sblib-partials", self.cont).detach();

            self._addEvents();
        });

    
    }
    
    getFileOrder()
    {
        var list = [];
        $(".sblib-files > .sblib-file", this.cont).each(function()
        {
            var info = $(this).data('info');
            list.push(info.value);
        });
    
        return list.join(',');
    }

    renderFolderPane(folderId)
    {
        var self = this;
        var post = {
         //   library : this.library,
            folder : this.folder
        };

        var promise = $.post(this.options.url + '/folder-list', post, function(data)
        {
            if  (!data || data.type != 'success') {
                return;
            }

            $('.sblib-folders', this.cont).html(data.html);

            self.folderEvents();

            self.activeFolder(folderId);
        });

        return promise;
    }
    
    folderEvents()
    {
        var self = this;
        var hierarchy = new SbHierarchy($($(".sblib-folders", self.cont)), {
            inlineEdit: true,
            actionPath: this.options.url,
            actionPrefix: "folder-",
            template: $(".sblib-folder-template", self.partials).html()
        });
         
        $('.hierarchy-base', self.cont)
        .on("click", "li", function(evt)
        {
            evt.stopPropagation();
            var id = $(this).data("id");    

        /*
            $('.hierarchy-base .is-active', self.cont).removeClass('is-active');
            $('.sblib-home.is-active', self.cont).removeClass('is-active');
            $(this).parentsUntil(".hierarchy-base", "li")
            .add(this)
            .addClass('is-active');
        */

            if (!self.clickTimeout) {
                self.clickTimeout = setTimeout(function()
                {
                    self.clickTimeout = null;

                    self.renderFilePane(id);

                }, self.options.mode == "folder" ? 300 : 20);
            }
         
        })
        .on('dblclick', "li", function(evt)
        {
            if (self.options.mode != "folder") {
                return;
            }

            evt.stopPropagation();

            if (self.clickTimeout) {
                clearTimeout(self.clickTimeout);
                self.clickTimeout = null;
                self.chooseFolder($(this).data('id'));
            }
        });

        // focus on folder when adding new file
        hierarchy.on("insert", function(evt, data)
        {
            data.li.addClass("sblib-folder-" + data.id);
            self.renderFilePane(data.id);
        });
 
        // back to home screen
        $('.sblib-secondary', self.cont)
        .on("click", ".sblib-home", function()
        {
            self.renderFilePane("0");

        /*
            $('.hierarchy-base .is-active', self.cont).removeClass('is-active');
            $(this).addClass('is-active');
        */
        });
    
        var counter = 0;
        $(".sblib-folders", self.cont).on("dragenter", ".hierarchy-row, .sblib-home", function(evt)
        {
            if (self.dragData.action != "moveFile") {
                return;
            }

            var row = $(this);
            
            // we don't want to drag into our current folder
            var id = (row.hasClass('sblib-home') ? row : row.closest('li')).data('id');
            if (id == self.folder) {
                return;
            }

            evt.preventDefault();
            evt.stopPropagation();

            row.data('counter', (row.data('counter') || 0) + 1); // refcounter to prevent leave event from firing prematurely
            
            row.addClass("sblib-folder-dragover");
        });

        $(".sblib-folders", self.cont)
        .on("dragover", ".hierarchy-row, .sblib-home", function(evt)
        {
            if (self.dragData.action != "moveFile") {
                return;
            }

            // we don't want to drag into our current folder
            var row = $(this);
            var id = (row.hasClass('sblib-home') ? row : row.closest('li')).data('id');
            if (id == self.folder) {
                return;
            }

            evt.preventDefault();
            evt.stopPropagation();
        })
        .on("dragleave", ".hierarchy-row, .sblib-home", function(evt)
        {
            if (self.dragData.action != "moveFile") {
                return;
            }

            var row = $(this);

            // we don't want to drag into our current folder
            var id = (row.hasClass('sblib-home') ? row : row.closest('li')).data('id');
            if (id == self.folder) {
                return;
            }

            evt.preventDefault();
            evt.stopPropagation();

     //       var li = row.closest('li');
            row.data('counter', (row.data('counter') || 0) - 1); // refcounter to prevent leave event from firing prematurely
          //  counter --;
            if (row.data("counter")!== 0) {
                return;
            }            

            row.removeClass("sblib-folder-dragover");
        })
        .on("drop dragdrop", ".hierarchy-row, .sblib-home", function(evt)
        {
            if (self.dragData.action != "moveFile") {
                return;
            }
            evt.preventDefault();
            evt.stopPropagation();

            var row = $(this);
            row.removeClass("sblib-folder-dragover");

            var id = (row.hasClass('sblib-home') ? row : row.closest('li')).data('id');

            var post = {
                folder: id,
                files:  self.dragData.files
            };
            var nodes = self.dragData.nodes;
            self.dragData.folderChange = true;

            self.action('folder-move', post, function()
            {
                var remove = function() {
                        $(this).remove();
                };

                for (var i = 0, node; (node = nodes[i]); i++) {
                    $(node).hide(200, remove); 
                }
            }); 
        });

    }

    addFile(info, isUpload)
    {
        var self = this;
        var value = info.value;
        var resource;
        
        var id = info.value ? this.options.id + 'sblib-file-' + value : '';
        var html = '';
        html += '<div id="' + id + '" class="sblib-file" draggable="true">';
        html += '   <div class="sblib-icon">';
        html += '   <img draggable="false"/>';
        html += '   </div>';
        if (this.options.type == 'file') {
            html += '   <div class="sblib-filename">' + info.name + '</div>';
        }
        html += '</div>';

        var node = $(html);
        node.data('info', info);

        if (info.value && $('#' + id).length) {
            $('#' + id).replaceWith(node);
        } else {
            $(".sblib-files", this.cont).append(node);
        }

        if (isUpload) {
            node.addClass('uploading');
            
            node.append(
                '<div class="sblib-progress">' +
                '    <div class="sblib-progress-indicator"></div>' +
                '</div>'
            );
        }

        var img = $(".sblib-icon img", node);
        if (this.options.type == 'image') {
            if (isUpload) {
                var reader = new FileReader();
                reader.onload = function(evt)
                {
                    img.prop('src', evt.target.result);
                    delete info.file;
                };
                reader.readAsDataURL(info.file);
            } else {
                img.prop('src',  info.sizes['library-thumb'].src);
            }
        } else {
            img.prop('src', this.getIcon(info));
        }

        node.on('contextmenu', function(evt)
        {
            evt.preventDefault();
            
            var node = $(this);
            node.addClass("selected-contextmenu");
            var y = evt.offsetY;
            var x = evt.offsetX;
            
            var dialog = new jqueryDialog(node, function()
            {
               
                var html = $(".sblib-context-menu", self.partials).prop('outerHTML');
                this.dialog.append(html);
                self.contextMenuEvents(dialog, node);
        
            }, {
                contextmenu: true,
                'position' : function()
                 {
                    this.dialog.css({
                        top : this.button.top + y,
                        left : this.button.left + x
                    });
                }
            }).open();    
            $(dialog).on("afterclose", function()
            {
                node.removeClass("selected-contextmenu");
            });

        });

        return node;
    }

    queue(file, replaceValue)
    {
        /* Ensure file has one of the allowed extensions
        */
        if (this.options.extensions.length) {
            var ext = file.name.match(/\.([^.]+)$/)[1].toLowerCase();
            if (this.options.extensions.indexOf(ext) == -1) {
                return;
            }
        }

        var info = {
            file : file,
            name : file.name,
            size : file.size,
            type : file.type,
            value : replaceValue
        };

        var node;
        if ((node = this.addFile(info, file))) {
            this._filesToUpload.push({
                node : node,
                file : file
            });
            this.processQueue();
        }

        // make sure upload is visible
        var primary = $(".sblib-primary", this.cont);
        primary.scrollTop(primary.prop("scrollHeight"));
    }

    processQueue()
    {
        var count = 0;
        for (var i = 0, item; (item = this._filesToUpload[i]); i++) {
            count ++;
            if ($(item.node).data('uploading') === true) {
                continue;
            }

            if (count >= 3) {
                break;
            }

            this.upload(item);
        }
    }
    
    upload(item)
    {
        var self = this;
        var node = item.node;
        var file = item.file;
        var info = node.data('info');

        $(node).data('uploading', true);
    
        var formData = new FormData();
        formData.append('file', file);
        formData.append('folder', this.folder);

        if (info.value) {
            formData.append('id', info.value);
        }

        var uploadError = function(message)
        {
            alert(message);
            node.fadeOut(function()
            {
                node.remove();
            });        
        };

        var xhr = new XMLHttpRequest();
        xhr.onload = function(e)
        {
            var index = self._filesToUpload.indexOf(item);
            if (index != -1) {
                self._filesToUpload.splice(index, 1);
                self.processQueue();
            }

            if (this.getResponseHeader('content-type') != "application/json") {
                uploadError("Error uploading file");            
                return;
            }
            
            var data;
            try {
                data = JSON.parse(this.responseText);
            } catch (ex) {
                uploadError("Error uploading file; please check your file sizes and try again.");
                return;
            }

            if (data.type == 'error') {
                uploadError(data.message);            
                return;
            }
        
            info = data.info;

            
            // for images where the orientation changes, change the image
            if (self.options.type == "image") {
                var img = new Image();
                img.onload = function()
                {
                    $(".sblib-icon img", node)
                    .prop('src', info.sizes['library-thumb'].src);
                };
                img.src = info.sizes['library-thumb'].src;
            }

            $(node).data('uploading', false);
            $(node).removeClass('uploading');
            node.data('info',  info);
            node.prop('draggable', true);
            $(".sblib-progress", node).fadeOut();
        };

        xhr.upload.onprogress = function(evt)
        {
            var percent = (evt.loaded / evt.total) * 100;
            $(".sblib-progress-indicator", node).css('width', percent);
        };

        xhr.onerror = function()
        {
            alert("Error uploading file");
        };

        xhr.open('POST', this.options.url + "/upload", true);
        xhr.send(formData);  // multipart/form-data
    }

    getMode(info)
    {
        return 'image';
    }

    getIcon(info)
    {
        var matches = info.name.match(/\.([^.]+)/);
        var ext = '';

        if (matches) {
            ext = matches[1].toLowerCase();
        }

        var icon = this.options.path + "/icons/" + (this.options.icons[ext] || 'no_file_type.png');

        return icon;
    }

    choose(data)
    {
        var value = data.value;
        if (this.field) {
            this.field.value = value;
        }
        this.trigger('choose', data);

        if (this.options.field) {
            var field = $(this.options.field).val(data.value);
            var cont = field.closest(".sblib-field");
            var thumb = cont.find(".sblib-thumb");
            var noImage = cont.find(".sblib-no-image");

            var img = field.parent().find(".sblib-thumb-image")
            .prop('src', this.options.type == "image" ? data.sizes['library-thumb'].src : this.getIcon(data));

            
            noImage.css('display', 'none');
            thumb.css('display', '');
        }

        if (this.dialog) {
            this.dialog.close();
            this.dialog = null;
        }
    }

    chooseFolder(folderId)
    {
        if (this.options.field) {
            var field = $(this.options.field).val(folderId);
       
            var cont = field.closest(".sblib-field");
            var thumb = cont.find(".sblib-thumb");
            var noImage = cont.find(".sblib-no-image");
        
       
            var div = cont.find(".sblib-folder-name");

            var folder = $(".sblib-folders", this.cont).find("li[data-id=" + folderId + "]");
            div.text(folder.children(".hierarchy-row").text());

            
            noImage.css('display', 'none');
            thumb.css('display', '');
        }

        if (this.dialog) {
            this.dialog.close();
            this.dialog = null;
        }
    }
    
    contextMenuEvents(menu, file)
    {
        var self = this;
        var info = file.data('info');

        // Remove html elements from template that do not apply
        switch (this.options.type) {
        case 'image':
            $(".sblib-file-only").remove();
            break;
        case 'file':
            $(".sblib-image-only").remove();
            $(".sblib-context-download a", menu.dialog).attr({
                'href' : info.path,
                'download' : info.name
            });

            break;
        }

        $(".sblib-context-download", menu.dialog).on("click", function(evt)
        {
            menu.close();
            evt.stopPropagation();
        });

        $(".sblib-context-view", menu.dialog).on("click", function(evt)
        {
            menu.close();
            evt.stopPropagation();
            
            self.addEditor(file);

        });

        $(".sblib-context-delete", menu.dialog).on("click", function(evt)
        {
            menu.close();
            evt.stopPropagation();

            var info = file.data('info');

            if (!info.value) {
                alert("Unable to delete file, no value");
                return;
            }

            if (!confirm("Are you sure you want to permanently remove this file?")) {
                return;
            }

            file.hide(200, function()
            {
               // file.remove();
            });

            $.post(self.options.url + "/delete", {id : info.value}, function(data)
            {
                if (data.type == "success") {
            
                    // blah
                    if (self.options.field) {
                        var field = $(self.options.field);

                        if (field.val() == info.value) {
                            self.remove();                    
                        }
                    }
                    file.remove();
                } else {
                    alert("Error deleting file");
                    file.show(200);
                }
            });
        });

    }
    
    action(action, post, callback)
    {
        var path = this.options.url + "/" + action;
        $.post(path, post, function(data)
        {
            if (typeof(data) != "object") {
                alert("Error retrieving action:\n" + data);
                return;
            }

            switch (data.type) {
            case "error":
                alert(data.message);
                break;
            case "success":
                if (callback) {
                    callback.call(this, data);
                }
                break;
            }
        }).fail(function(xhr)
        {
            alert("Error performaing action:\n" + xhr.statusText);

        //    alert(this.responseText);

        });
    }

/*
    addEscape(callback)
    {
        this._escapes.push(callback);

    }

    clearEscape(index)
    {
        var length = this._escapes.length;

        if (typeof(index) == "undefined") {
            index = length - 1;   
        }
        for (var i = index, callback; (callback = this._escapes[i]); i++) {
            callback.call(this);
        }

        this._escapes.splice(index, length - index);
    }
*/

    addEditor(node)
    {
     //   jqueryDialog.disableEscape = true;
        var info = node.data("info");
        if (info.type !== "image") {
            return false;
        }

        var self = this;
        var primary = $(".sblib-primary", this.cont);
        var pOffset = primary.offset();
        var offset = node.offset();

        var left = offset.left - pOffset.left + (node.outerWidth() / 2);
        var top = offset.top - pOffset.top + (node.outerWidth() / 2);

        var editor = $(".sblib-editor", self.partials).clone();

        $(".sblib-editor-image", editor).prop("src", info.sizes.display.src);

        for (var key in self.data.sizes) {
            var size = self.data.sizes[key];


            var tr = $("<tr />");
            tr.append("<td>" + size.title + "</td>");
            if ((size = info.sizes[key])) {
                tr.append("<td>" + size.width + "</td>");
                tr.append("<td>" + size.height + "</td>");
            }

            $(".sblib-editor-sizes tbody", editor).append(tr);
        }

        $(".sblib-editor-filename", editor).text(info.name);

        this.addField(editor, info, 'title');
        this.addField(editor, info, 'description');
        this.addField(editor, info, 'alt');

        $(".sblib-primary", self.cont).append(editor);
        TweenMax.from(editor, 0.3, {
            ease:Power0.easeOut,
            transformOrigin: left + "px " + top + "px", // try changing value
            scale: 0.1
        });

        var editorClose = function()
        {
          //  jqueryDialog.disableEscape = false;

            TweenMax.to(editor, 0.3, {
                ease:Power0.easeIn,
                transformOrigin: left + "px " + top + "px", // try changing value
                scale: 0.1,
                onComplete: function()
                {
                    editor.remove();
                }
            });
        };

      //  self.addEscape(editorClose);
        SbEscape.add(editor, editorClose);
        $(".sblib-editor-close", editor).on("click", editorClose);
    }

    addField(editor, info, field_name)
    {
        var self = this;
        $(".sblib-editor-" + field_name, editor)
        .val(info[field_name])
        .on("change", function()
        {
            var post = {
               id: info.value,
               field: this.name,
               value: this.value 
            };
            info[this.name] = this.value;

            self.action("save-meta", post);
        });
    }


    rteAction()
    {
    
    }
}

